import { render, staticRenderFns } from "./cat-status-show.vue?vue&type=template&id=c8c7a7c2&"
import script from "./cat-status-show.vue?vue&type=script&lang=js&"
export * from "./cat-status-show.vue?vue&type=script&lang=js&"
import style0 from "./cat-status-show.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports